// Triggered in Block

import { ON_CHANGE_BLOCK_ORDER } from '../state-constants/stateConstants';

export const onChangeBlockOrder = (array) => ({
  type: ON_CHANGE_BLOCK_ORDER,
  payload: array,
});



// WEBPACK FOOTER //
// ./src/state-actions/onChangeBlockOrder.js